import { render, staticRenderFns } from "./AddUser.vue?vue&type=template&id=1e45b56a&scoped=true"
import script from "./AddUser.vue?vue&type=script&lang=js"
export * from "./AddUser.vue?vue&type=script&lang=js"
import style0 from "./AddUser.vue?vue&type=style&index=0&id=1e45b56a&prod&lang=scss&scoped=true"
import style1 from "./AddUser.vue?vue&type=style&index=1&id=1e45b56a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e45b56a",
  null
  
)

export default component.exports